import { z } from 'zod';

import { Option } from '../../types/Option';

const communicationInterfaces = [
    'ethernet',
    'rs232',
    'rs485',
    'wifi',
    'io-link',
    'digital-io',
    'analog-io',
    'can',
] as const;

type CommunicationInterface = (typeof communicationInterfaces)[number];

const options: Option<CommunicationInterface>[] = [
    { value: 'ethernet', label: 'Ethernet' },
    { value: 'rs232', label: 'RS-232' },
    { value: 'rs485', label: 'RS-485' },
    { value: 'wifi', label: 'Wi-Fi' },
    { value: 'io-link', label: 'IO-Link' },
    { value: 'digital-io', label: 'Digital I/O' },
    { value: 'analog-io', label: 'Analog I/O' },
    { value: 'can', label: 'CAN' },
];

export const CommunicationInterfaces = {
    validator: z.array(z.enum(communicationInterfaces)),
    options,
};

export type CommunicationInterfaces = z.infer<typeof CommunicationInterfaces.validator>;
